module.exports = __webpack_public_path__ + "static/media/christmas_sub.68dce1d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/christmas_sub.png
// module id = 148
// module chunks = 0